<template>
  <div ref="searchPopup"
       v-on="touchEvent"
       class="search-popup"
       :class="{'search-popup--empty': isPopupEmpty}">
    <ul v-if="shouldHistoryShow && searchHistory" class="search-popup__history">
      <li class="search-popup__list-item search-popup__list-item--history"><span class="search-popup__title">{{ $t('history_title') }}</span><span class="link link--pseudo link--clear_history" @click="CLEAR_HISTORY">{{ $t('clear_history') }}</span></li>
      <li
        class="search-popup__list-item"
        :class="{'search-popup__list-item--hover': arrowSelectedItem.text === item.text}"
        v-for="(item, i) in searchHistory"
        :key="i">
        <a class="search-popup__history-item search-popup__history-link" :href="urlLanguagePrefix + '/catalog/search/?text=' + item.text">{{ item.text }}</a>
      </li>
    </ul>
    <ul class="search-popup__autocomplete" v-if="suggested.length">
      <li
        class="search-popup__list-item search-popup__autocomplete-item"
        :class="{'search-popup__list-item--hover': arrowSelectedItem.text === item && arrowSelectedItem.isSuggested}"
        v-for="(item, i) in suggested"
        :key="i">
        <a :href="urlLanguagePrefix + '/catalog/search/?text=' + item" @click.prevent="sendSuggestHistory(urlLanguagePrefix + '/catalog/search/?text=' + item, item)" class="autocomplete-text">{{ autocompleteNormalText(item) }}<b>{{ autocompleteBoldText(item) }}</b></a>
        <svg class="search-icon"
             width="13"
             height="14"
             viewBox="0 0 13 14"
             fill="none"
             xmlns="http://www.w3.org/2000/svg">
          <path d="M12.8446 13.14L9.75922 9.97543C10.7653 8.90909 11.4025 7.46437 11.4025 5.84766C11.4025 2.61425 8.85372 0 5.70126 0C2.5488 0 0 2.61425 0 5.84766C0 9.08108 2.5488 11.6953 5.70126 11.6953C6.90859 11.6953 8.04884 11.2825 8.98787 10.629L12.1403 13.8624C12.2409 13.9656 12.3751 14 12.5092 14C12.6434 14 12.7775 13.9656 12.8781 13.8624C13.0458 13.656 13.0458 13.3464 12.8446 13.14ZM1.0061 5.84766C1.0061 3.19902 3.11892 1.03194 5.70126 1.03194C8.2836 1.03194 10.3964 3.19902 10.3964 5.84766C10.3964 8.49631 8.2836 10.6634 5.70126 10.6634C3.11892 10.6634 1.0061 8.49631 1.0061 5.84766Z" fill="#BDBDBD"/>
        </svg>
      </li>
      <li class="search-popup__horiznotal-line"></li>
    </ul>
    <ul v-if="searchBarInfo && searchBarInfo.categories && searchBarInfo.categories.length" class="search-popup__categories">
      <li><span class="search-popup__title">{{ $t('categories') }}</span></li>
      <li>
        <a
          @click.prevent="sendSuggestHistory(item.url, item.name[language])"
          :href="item.url"
          class="search-popup__list-item search-popup__categories-item"
          :class="{'search-popup__list-item--hover': arrowSelectedItem.text === item.name[language] && arrowSelectedItem.isCategory}"
          v-for="item in searchBarInfo.categories"
          :key="item.id">
          <span class="search-popup__categories-item-text">{{ item.name[language] }}</span>
          <svg width="8"
               height="14"
               viewBox="0 0 8 14"
               fill="none"
               xmlns="http://www.w3.org/2000/svg"><path d="M1 1L7 7L1 13" stroke="#909090"/></svg>
        </a>
      </li>
      <li class="search-popup__horiznotal-line"></li>
    </ul>
    <ul v-if="searchBarInfo && searchBarInfo.products && searchBarInfo.products.length" class="search-popup__products">
      <li><span class="search-popup__title">{{ $t('products') }}</span></li>
      <li
        @click.prevent="sendSuggestHistory(product.url, product.name[language])"
        class="search-popup__product-item search-popup__list-item"
        :class="{'search-popup__list-item--hover': arrowSelectedItem.text === product.name[language] && arrowSelectedItem.isProduct}"
        v-for="product in searchBarInfo.products"
        :key="product.id"
        :product="{
          id: product.id,
          name: product.name[language],
          imageUrl: product.product_photo,
          price: product.price_new,
          price_old: product.price_old,
          currency: currency,
          productUrl: product.url,
          arrivalDate: product.arrival_date,
          isAvailable: product.is_available
        }">
        <a :href="product.url"><img :src="product.product_photo" :alt="product.name[language]" class="search-popup__product-item-img"></a>
        <div class="search-popup__product-item-info">
          <a :href="product.url" class="search-popup__product-item-info-link">{{product.name[language]}}</a>
          <span v-if="product.arrivalDate && !product.is_available" class="product-info__price product-info__price--unavailable">
            {{ product.arrival_date }}
          </span>
          <div v-else-if="+product.price_new || +product.price_old" class="search-popup__product-item-info-prices">
            <span v-if="+product.price_old" class="search-popup__product-item-price search-popup__product-item-price--old">
              {{product.price_old | CurrencyFormatter}}
            </span>
            <span
              class="search-popup__product-item-price"
              :class="{'search-popup__product-item-price--unavailable': !product.is_available, 'search-popup__product-item-price--red': +product.price_old}">
              {{product.price_new | CurrencyFormatter}}
            </span>
          </div>
          <div v-else class="product-info__price product-info__price--unavailable">
            {{ $t('unavailable_novelty_badge') }}
          </div>
        </div>
      </li>
    </ul>
    <a
      v-if="!isPopupEmpty"
      :href="computedLink"
      @click="handleRedirect({ e: $event, link: computedLink })"
      class="link search-popup__link">{{ $t('show_search_results') }}
    </a>
    <span
      v-if="isPopupEmpty && !shouldHistoryShow"
      class="search-popup__empty-text">
      {{ $t('no_results') }}
    </span>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import CurrencyFormatter from '@/filters/CurrencyFormatter'

export default {
  name: 'SearchPopup',
  data () {
    return {
      headerHeigth: document.querySelector(`#header`).offsetHeight,
      documentHeight: window.innerHeight
    }
  },
  filters: { CurrencyFormatter },
  props: {
    isMobile: {
      type: Boolean,
      default: false,
      isSuggestLoading: false
    }
  },
  computed: {
    ...mapGetters(['urlLanguagePrefix', 'allPopupItems']),
    ...mapState({
      searchBarInfo: state => state.search.searchBarInfo,
      searchBarValue: state => state.search.searchBarValue,
      language: state => state.translation.language,
      suggested: state => state.search.suggested,
      arrowSelectedItem: state => state.search.arrowSelectedItem,
      searchHistory: state => state.search.searchHistory,
      shouldHistoryShow: state => state.search.shouldHistoryShow
    }),
    computedLink () {
      if (this.searchBarInfo && this.searchBarInfo.redirect_url) {
        return this.searchBarInfo.redirect_url
      }
      return this.urlLanguagePrefix + '/catalog/search/?text=' + this.searchBarValue
    },
    isPopupEmpty () {
      return (!this.searchBarInfo && !this.suggested.length) || (!this.suggested.length && this.searchBarInfo && this.searchBarInfo.products && this.searchBarInfo.categories && !this.searchBarInfo.products.length && !this.searchBarInfo.categories.length)
    },
    touchEvent () {
      const element = this
      return Object.assign({},
        this.$listeners,
        {
          touchmove: function (e) {
            element.$emit(`touchmove`)
          }
        })
    },
    currency () {
      return CurrencyFormatter('').trim()
    }
  },
  methods: {
    ...mapActions(['CLEAR_HISTORY', 'SEND_SUGGEST_HISTORY']),
    handleRedirect (event) {
      this.$emit('allResultsAction')
      const { e, link } = event
      e.preventDefault()
      location.href = link
    },
    autocompleteNormalText (text) {
      if (text.toLowerCase().indexOf(this.searchBarValue.toLowerCase())) {
        return ''
      }
      return this.searchBarValue
    },
    autocompleteBoldText (text) {
      if (text.toLowerCase().indexOf(this.searchBarValue.toLowerCase())) {
        return text
      }
      return text.toLowerCase().replace(this.searchBarValue.toLowerCase(), '')
    },
    sendSuggestHistory (url, text) {
      if (this.isSuggestLoading) return

      this.isSuggestLoading = true

      this.SEND_SUGGEST_HISTORY(text)
        .then(() => {
          location.href = url
        }).catch(() => {
          this.isSuggestLoading = false
        })
    }
  }
}
</script>

<style lang="sass" scoped>

.search-popup
  position: absolute
  width: 100%
  left: 0
  top: 50px
  height: calc(100vh - 50px)
  overflow: auto
  background: $white-text-color
  font-size: 14px
  z-index: 0
  padding-bottom: 63px

  +mmin($tablet--hor)
    top: 40px
    box-shadow: 0 1px 10px rgba(0, 0, 0, 0.15)
    border-radius: 0 0 3px 3px
    max-height: calc(100vh - 170px)
    height: auto
    overflow-y: auto
    padding-bottom: 0

  &--empty
    padding: 0

.search-popup__title
  color: #cccccc
  margin-bottom: 10px
  display: inline-block
  margin-left: 20px

.search-popup__products
  margin: 0 0 20px
  border-bottom: 1px solid #e7e7e7

.search-popup__categories, .search-popup__products, .search-popup__autocomplete, .search-popup__history
  +list-unstyled
  margin: 10px 0

.search-popup__categories-item, .search-popup__history-item
  display: flex
  justify-content: space-between
  align-items: center
  padding: 9px 20px
  cursor: pointer
  word-break: break-word

  &:hover
    background-color: $nd-disabled-background-color

.search-popup__categories-item-text
  color: $text-color

.search-popup__horiznotal-line
  background: #E7E7E7
  width: auto
  height: 1px
  margin: 10px 20px 20px

.search-popup__product-item
  cursor: pointer
  padding: 5px 20px
  border: 0
  display: flex

  //&:not(:last-child):after
  //  content: ''
  //  position: absolute
  //  bottom: 0
  //  width: calc(100% - 40px)
  //  height: 1px
  //  background: #E7E7E7

.search-popup__link
  display: inline-block
  padding-bottom: 23px
  margin-top: 10px
  margin-left: 20px

.search-popup__autocomplete-item
  display: flex
  align-items: center
  justify-content: space-between
  font-size: 14px
  cursor: pointer
  position: relative

  &:hover
    background-color: $nd-disabled-background-color

.autocomplete-text
  color: $text-color
  padding: 9px 40px 9px 20px
  width: 100%
  z-index: 1

  &:first-letter
    text-transform: uppercase

.search-popup__empty-text
  padding: 10px 20px
  display: inline-block

.search-icon
  position: absolute
  right: 20px
  top: 50%
  transform: translateY(-50%)
  z-index: 0

.search-popup__list-item--hover
  background-color: #f3f3f3

.search-popup__history-link
  color: $text-color

.link--clear_history
  float: right
  margin-right: 20px
  cursor: pointer

.search-popup__product-item-img
  margin-right: 20px
  width: 70px

.search-popup__product-item-info
  display: flex
  flex-direction: column
  justify-content: center
  width: calc(100% - 90px)

.search-popup__product-item-info-link
  color: $text-color
  margin-bottom: 10px

.search-popup__product-item-price
  font-size: 16px

  &--old
    text-decoration-line: line-through
    color: $placeholder-color
    font-size: 14px
    margin-right: 10px

  &--unavailable
    color: $placeholder-color

  &--red
    color: $main-color
    font-weight: 500
</style>
